module.exports = __webpack_public_path__ + "static/media/moonlight.2f431f53.svg";